import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map, Observable } from 'rxjs';
import { District, Ward } from '../models';

@Injectable({
    providedIn: 'root'
})
export class CountryApiService {
    private apiService = inject(ApiService);

    getDistricts(region_id = 0): Observable<District[]> {
        return this.apiService.get<District[]>('towns', { params: { region_id } }).pipe(
            map(response =>
                response.map(item => ({
                    ...item,
                    name: `${item.prefix} ${item.name}`
                }))
            )
        );
    }

    getWards(town_id: number): Observable<Ward[]> {
        return this.apiService.get<Ward[]>('wards', { params: { town_id } }).pipe(
            map(response =>
                response.map(item => ({
                    ...item,
                    name: `${item.prefix} ${item.name}`
                }))
            )
        );
    }
}
